"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiParticleEmitter = void 0;
var _pixiParticles = require("pixi-particles");
var _core = require("@dragon/core");
var _pixiGame = require("@dragon/pixi-game");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * This handles and emits a single type of animated win particles, such as diamonds, jewels or coins.
 */
var PixiParticleEmitter = exports.PixiParticleEmitter = /*#__PURE__*/function (_PixiGameComponent) {
  function PixiParticleEmitter(componentName, textures, baseDesktopConfigOverride, baseMobileConfigOverride) {
    var _this;
    _classCallCheck(this, PixiParticleEmitter);
    _this = _callSuper(this, PixiParticleEmitter, [componentName]);

    // if no name provided, dont register.
    _defineProperty(_this, "_defaultMobileConfig", {
      "alpha": {
        "start": 1,
        "end": 1
      },
      "scale": {
        "start": 1,
        "end": 0.6,
        "minimumScaleMultiplier": 1
      },
      "color": {
        "start": "#ffffff",
        "end": "#ffffff"
      },
      "speed": {
        "start": 400,
        "end": 0,
        "minimumSpeedMultiplier": 1
      },
      "acceleration": {
        "x": 0,
        "y": 1000
      },
      "maxSpeed": 0,
      "startRotation": {
        "min": 250,
        "max": 300
      },
      "noRotation": false,
      "rotationSpeed": {
        "min": 0,
        "max": 360
      },
      "lifetime": {
        "min": 2,
        "max": 2
      },
      "blendMode": "normal",
      "frequency": 0.12,
      "emitterLifetime": -1,
      "maxParticles": 1000,
      "pos": {
        "x": 0,
        "y": 0
      },
      "addAtBack": true,
      "spawnType": "circle",
      "spawnCircle": {
        "x": 0,
        "y": 0,
        "r": 20
      }
    });
    _defineProperty(_this, "_defaultDesktopConfig", {
      "alpha": {
        "start": 1,
        "end": 1
      },
      "scale": {
        "start": 1.5,
        "end": 0.7,
        "minimumScaleMultiplier": 1
      },
      "color": {
        "start": "#ffffff",
        "end": "#ffffff"
      },
      "speed": {
        "start": 600,
        "end": -500,
        "minimumSpeedMultiplier": 1
      },
      "acceleration": {
        "x": 0,
        "y": 900
      },
      "maxSpeed": 0,
      "startRotation": {
        "min": -180,
        "max": 0
      },
      "noRotation": false,
      "rotationSpeed": {
        "min": 0,
        "max": 1080
      },
      "lifetime": {
        "min": 3,
        "max": 3
      },
      "blendMode": "normal",
      "frequency": 0.12,
      "emitterLifetime": -1,
      "maxParticles": 1000,
      "pos": {
        "x": 0,
        "y": 0
      },
      "addAtBack": true,
      "spawnType": "point"
    });
    _defineProperty(_this, "_emitter", void 0);
    _defineProperty(_this, "_elapsed", void 0);
    _defineProperty(_this, "_hasStarted", false);
    _defineProperty(_this, "_tickerUpdateBind", void 0);
    _defineProperty(_this, "_textures", void 0);
    _defineProperty(_this, "_orgConfig", void 0);
    _defineProperty(_this, "_currentTimeScale", 1);
    if (componentName) {
      _this.name = componentName;
      //Register in component registry.
      _core.gameEmitterRegistry.register(_this);
    }
    _this._textures = textures;
    var channel = _core.CORE.getState().config.channel;
    var config = channel === _core.Channel.Mobile ? _this._defaultMobileConfig : _this._defaultDesktopConfig;
    if (channel === _core.Channel.Mobile && baseMobileConfigOverride) {
      config = _objectSpread(_objectSpread({}, config), baseMobileConfigOverride);
    } else {
      // if no mobile override was given, we use desktop override for mobile as well.
      config = _objectSpread(_objectSpread({}, config), baseDesktopConfigOverride);
    }
    _this._emitter = new _pixiParticles.Emitter(_this, textures, config);
    _this._emitter.emit = true;
    _this._tickerUpdateBind = _this.update.bind(_this);
    _this._elapsed = Date.now();
    return _this;
  }
  _inherits(PixiParticleEmitter, _PixiGameComponent);
  return _createClass(PixiParticleEmitter, [{
    key: "timeScale",
    value: function timeScale(scale) {
      this._currentTimeScale = scale;
      return scale;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(PixiParticleEmitter, "destroy", this, 3)([]);
      this.stop();
      this.application.ticker.remove(this._tickerUpdateBind);
      this._emitter.destroy();
    }
  }, {
    key: "start",
    value: function start(coinSpawnInterval) {
      if (coinSpawnInterval) this._emitter.frequency = coinSpawnInterval;
      this._elapsed = Date.now();
      this._emitter.emit = true;
      this._hasStarted = true;
      this.application.ticker.add(this._tickerUpdateBind);
    }
    /**
     * Stop emitting particles
     */
  }, {
    key: "stop",
    value: function stop() {
      this._hasStarted = false;
      this._emitter.emit = false;
    }
  }, {
    key: "update",
    value: function update() {
      var now = Date.now();
      this._emitter.update((now - this._elapsed) * (0.0007 * this._currentTimeScale));
      this._elapsed = now;
      if (this._emitter.particleCount == 0 && !this._hasStarted) {
        this.application.ticker.remove(this._tickerUpdateBind);
      }
      ;
    }
  }, {
    key: "puff",
    value: function puff(duration, coinSpawnInterval) {
      var _this2 = this;
      this.start(coinSpawnInterval);
      setTimeout(function () {
        _this2.stop();
      }, duration);
    }
  }]);
}(_pixiGame.PixiGameComponent);
//# sourceMappingURL=PixiParticleEmitter.js.map